module.exports = __webpack_public_path__ + "static/media/iMix_m2m_Proffessional.dc4fe313.png";